import { CellContext } from '@tanstack/react-table'
import { DotsThree, Eye } from '@phosphor-icons/react'
import * as React from 'react'
import { OrgPersonalSkillsTableRow } from '../data'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { useTable } from '../context/table'

export const ActionsCell = (
  data: CellContext<OrgPersonalSkillsTableRow, unknown>
) => {
  const row = data.row.original
  const { setSelectedSkillId } = useTable()

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="p-1 rounded hover:bg-gray-100">
          <DotsThree className="h-5 w-5 text-gray-500" weight="bold" />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="bg-white rounded-md shadow-lg border border-gray-200 p-1 min-w-[120px]"
          align="end"
        >
          <DropdownMenu.Item
            className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded cursor-pointer outline-none"
            onSelect={() => {
              setSelectedSkillId(row.id)
            }}
          >
            <Eye className="h-4 w-4" />
            View
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
